import type { GatsbyBrowser } from "gatsby";
import React from "react";
import { AppProvider } from "./src/components/app-context";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return <AppProvider>{element}</AppProvider>;
};
